const bannerBtnWidthAdjust = () => {
  const bannerBtnContainers = document.querySelectorAll('.banner__buttons-inner, .banner__button-container-inner');
  if (bannerBtnContainers.length === 0) return;
  bannerBtnContainers.forEach((container) => {
    const containerTop = container.offsetTop;
    const bannerBtns = container.querySelectorAll('.button');
    let resizeBtnTrigger = false;
    let maxBtnWidth = 0;
    bannerBtns.forEach((btn) => {
      const btnTop = btn.offsetTop;
      resizeBtnTrigger = btnTop !== containerTop ? true : false
      const btnRect = btn.getBoundingClientRect();
      const btnWidth = btnRect.width;
      btnWidth > parseFloat(maxBtnWidth) ? (maxBtnWidth = btnWidth) : null;
    });
    if (resizeBtnTrigger === false) return;
    if (window.innerWidth < 768) {
      container.style.width = '100%';
      bannerBtns.forEach((btn) => {
        btn.style.flexGrow = 0;
      });
      return;
    } else {
      container.style.width = maxBtnWidth + 'px';
      bannerBtns.forEach((btn) => {
        btn.style.flexGrow = 1;
      });
    };
  });
};

domReady(() => {
  bannerBtnWidthAdjust();
  window.addEventListener('resize', bannerBtnWidthAdjust);
});